<h2 class="mb-2">
  <p id="ajouter-document" class="titre2 m-4">
    {{ 'PROFIL_UTILISATEUR.DOCUMENT_TITRE_AJOUTER_DOCUMENT_UTILISATEUR' | translate }}
  </p>
</h2>
@if (utilisateur) {
  <div class="m-4 mb-2 text-lg font-semibold">
    {{ 'PROFIL_UTILISATEUR.NOM_LABEL' | translate }} {{ utilisateur.prenom }} {{ utilisateur.nom }}
  </div>
}
@if (isLoading) {
  <div class="flex justify-center items-center h-64">
    <mat-spinner color="accent"></mat-spinner>
  </div>
}
@if (!isLoading) {
  <div>
    <div class="flex gap-3 mb-2 m-4">
      <div class="w-1/2 flex flex-col">
        <div class="mb-2">
          <label [for]="'nom' + language" class="block text-sm font-medium mb-1">
            {{ 'PROFIL_UTILISATEUR.DOCUMENT_NAME' | translate }}:<span class="required-asterisk">*</span>
          </label>
          <input title="nom" [id]="'nom' + language" [(ngModel)]="nom" [name]="'nom' + language"
            required
            class="w-full rounded-md border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200">
          </div>
          <div class="flex-grow flex flex-col justify-between">
            @if (contentType === 'pdf') {
              <label class="block text-sm font-medium mb-1">
                {{ 'PROFIL_UTILISATEUR.DOCUMENT_PDF_FILE' | translate }}:<span class="required-asterisk">*</span>
              </label>
              @if (!file) {
                <div (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
                  [class.border-red-500]="isDragging" [class.bg-red-50]="isDragging" [class.scale-105]="isDragging"
                  [class.shadow-md]="isDragging" [class.border-2]="isDragging"
                  class="cursor-pointer border border-gray-300 border-dashed rounded-md p-2 hover:border-red-400 transition-all duration-200">
                  <div class="text-center">
                    <input [id]="'pdfFile' + language" type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.gif,.webp" class="hidden"
                      (change)="onFileSelected($event)" />
                      <label [for]="'pdfFile' + language" class="cursor-pointer text-xs text-red-600 hover:text-red-700">
                        {{ 'PROFIL_UTILISATEUR.DOCUMENT_UPLOAD_PDF' | translate }}
                      </label>
                      <p class="text-xs text-gray-500 mt-0">{{ 'PROFIL_UTILISATEUR.DOCUMENT_OR_DRAG_DROP' | translate }}
                        •
                      {{ 'PROFIL_UTILISATEUR.DOCUMENT_UP_TO_10MB' | translate }}</p>
                    </div>
                  </div>
                }
                @if (fileError) {
                  <p role="alert" class="text-xs text-red-600 mt-1">{{ fileError | translate }}</p>
                }
                <div class="flex-shrink-0 mt-2">
                  <input type="checkbox" class="form-checkbox h-4 w-4 transition duration-150 ease-in-out mr-2 mb-2 rounded-sm" [checked]="estVisible" [(ngModel)]="estVisible" />
                  {{ 'PROFIL_UTILISATEUR.VISIBLE_UTILISATEUR' | translate }}
                </div>
                @if (file) {
                  <div class="flex items-center justify-between bg-gray-50 p-1 rounded text-xs">
                    <span class="truncate p-2 text-gray-600 max-w-[180px]">{{ file.name }}</span>
                    <button type="button" (click)="removeFile()" class="text-red-500 hover:text-red-700">
                      <mat-icon class="text-sm h-4 w-4"><span class="material-symbols-outlined">
                        close
                      </span>
                    </mat-icon>
                  </button>
                </div>
              }
            }
          </div>
        </div>
        <div class="w-1/2 flex flex-col">
          <label [for]="'description' + language" class="block text-sm font-medium mb-1">
            {{ 'PROFIL_UTILISATEUR.DOCUMENT_DESCRIPTION' | translate }}:<span class="required-asterisk">*</span>
          </label>
          <textarea title="description" [id]="'description' + language" [(ngModel)]="description"
            [name]="'description' + language" required
            class="w-full rounded-md border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200 flex-grow">
          </textarea>
        </div>
      </div>
      <div class="flex justify-end px-3 mt-4">
        <button type="button" (click)="annuler()" class="btn-secondary-novo">{{ 'PROFIL_UTILISATEUR.DOCUMENT_CANCEL' |
        translate }}</button>
        <button type="button" (click)="saveDocument()"
          [disabled]="!nom.trim() || !description.trim() || !file"
          class="btn-primary-novo disabled:opacity-50 disabled:cursor-not-allowed">{{ 'PROFIL_UTILISATEUR.DOCUMENT_SAVE' |
        translate }}</button>
      </div>
    </div>
  }
